/**
 * Service slugs the grid's fixed columns are keyed on.
 *
 * The grid has a column per service by design (brief §5), so these three are
 * structural rather than data-driven - re-exported from one place so the row
 * model, the footer and the column config cannot drift apart on a string.
 * The catalogue itself (labels, items, tag codes) still comes from the server.
 */
export const WEIGHT_SERVICE_SLUG = 'wash-and-iron'
export const DRY_CLEANING_SLUG = 'dry-cleaning'
export const SHOE_CARE_SLUG = 'shoe-care'
